import countryConfig from '@countryConfig/index';
import commonConfig from './common';
import { StaticConfig } from './types';

export default {
    ...commonConfig,
    countrySpecific: countryConfig,
} as unknown as StaticConfig;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/config/index.ts